import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DishCreateNamePage } from "../../dish-create/dish-create-name/dish-create-name";
import { Globals } from '../../../../globals';

/**
 * Generated class for the DishViewNamePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dish-view-name',
  templateUrl: 'dish-view-name.html',
})
export class DishViewNamePage {
  @Input() dish: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals) {
  }

  edit() {
    this.navCtrl.push(DishCreateNamePage, {
      update: true,
      dish_uid: this.dish.UID,
      name: this.dish.name_es,
      name_en: this.dish.name_en,
      name_fr: this.dish.name_fr,
      name_it: this.dish.name_it,
      name_de: this.dish.name_de,
      name_ca: this.dish.name_ca,
      tags: this.dish.tags,
      description_es: this.dish.description_es,
      description_en: this.dish.description_en,
      description_fr: this.dish.description_fr,
      description_it: this.dish.description_it,
      description_de: this.dish.description_de,
      description_ca: this.dish.description_ca,
      dish: this.dish
    })
  }



}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-view-name/dish-view-name.ts